import React from 'react';
import { hydrate, render } from 'react-dom';
import App from './App';
import './css/index.css';
import { unregister } from './registerServiceWorker';

const rootElement = document.getElementById('root');

while (rootElement.lastChild) {
  rootElement.removeChild(rootElement.lastChild);
}

if (rootElement.hasChildNodes()) {
    hydrate(<App />, rootElement);
} else {
    render(<App />, rootElement);
}

unregister();



// WEBPACK FOOTER //
// ./src/index.js